import { render, staticRenderFns } from "./QuestionTab.vue?vue&type=template&id=d8457dd2&"
import script from "./question-tab.js?vue&type=script&lang=js&"
export * from "./question-tab.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Data\\Projects\\Werk\\DPG\\DNX2-DPG\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d8457dd2')) {
      api.createRecord('d8457dd2', component.options)
    } else {
      api.reload('d8457dd2', component.options)
    }
    module.hot.accept("./QuestionTab.vue?vue&type=template&id=d8457dd2&", function () {
      api.rerender('d8457dd2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/AudienceManager/Components/Builder/QuestionTab/QuestionTab.vue"
export default component.exports